import React from 'react';
import { Sheet, Typography, Button, Box } from '@mui/joy';
import { useNavigate } from 'react-router-dom';

const DashboardOnboarding = ({onCreateEvent } : any) => {

    const navigate = useNavigate();

    return (  
    <Sheet
        variant="soft"
        sx={{
          bgcolor: 'background.surface',
          borderRadius: 'md',
          p: 5,
          textAlign: 'center',
          mx: 'auto',
          my: 8,
          maxWidth: 700,
        }}
      >
        <Typography level="h2" component="h1" gutterBottom sx={{ mb: 2 }}>
         Bienvenue sur eevenPro !
        </Typography>
        <Typography level="body-lg" sx={{ mb: 3 }}>
          Vous êtes à quelques clics seulement de créer votre premier événement. Une fois votre événement ajouté, vous retrouverez ici toutes les statistiques liées aux évènements en temps réel.
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          <Button size="lg" onClick={() => navigate("/events/create")}>
            Créer mon premier événement
          </Button>
        </Box>
      </Sheet>
      )

    };

export default DashboardOnboarding;